import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from '@app/_models';
import { AddUser } from '@app/_models/addUser';
import { UserService } from '@app/_services';
import { LogService } from '@app/_shared/log.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-user-master-add',
  templateUrl: './user-master-add.component.html',
  styleUrls: ['./user-master-add.component.css']
})
export class UserMasterAddComponent implements OnInit {

  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";
  user= new AddUser();
  userForm: FormGroup;
  submitted = false;
  roles: [];
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  strMessage;

  constructor(private eventService: LogService, private formBuilder: FormBuilder,  private SpinnerService: NgxSpinnerService,
    private userService: UserService, private modalService: NgbModal) { }

  ngOnInit(): void {

    this.userService.getRoles()
    .pipe(first())
    .subscribe(
      data => {
        console.log("getAllUsers response---", data)
        this.roles = data.respData;
      },
      error => {
        console.log(error)
      }
    )

    this.userForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      emailId: ['', Validators.required],
      password: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]],
      roleId: ['', Validators.required],
      universityId: 1,
      confirmPassword: ['']
    });

  }

  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('16');
  }

  get f() { return this.userForm.controls; }

  addUser(){
    this.submitted = true;

    // console.log("formValue--->", this.userForm.value)
    console.log("this.user--->", this.user)
    if(this.userForm.invalid){
      console.log("invalid")
    }else{
      console.log("VALID")

      this.userService.addUser(this.user)
      .pipe(first())
      .subscribe(
        data => {
          console.log("getAllUsers response---", data)
          if(data.respMessage == "Success"){
            this.SpinnerService.hide();
            this.strMessage="Verification mail sent to user. Please verify emailId.";
            this.modalService.open(this.showModalBoxTemplate);
            // alert('Verification Mail has been to user. Please verify the emailId.')
            // this.showModalBox = true;
            // this.modalService.open(this.showModalBoxTemplate);
          }else{
              this.SpinnerService.hide();
            this.strMessage = data.respData;
            this.modalService.open(this.showModalBoxTemplate);
          }
        },
        error => {
          console.log(error)
        }
      ),
      this.SpinnerService.show();

    }

  }
  goBack()
  {
    this.eventService.emit<string>('16');
  }

}
